import React from 'react';
import Input from '../../../../components/ui/Input';
import Select from '../../../../components/ui/Select';

const TaxDataTab = ({ productData, onFieldChange, validationErrors }) => {
  const originOptions = [
    { value: 'nacional', label: 'Nacional' },
    { value: 'importada', label: 'Importada' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 flex gap-3">
        <div className="text-warning mt-0.5">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div>
          <p className="text-sm font-medium text-foreground">Dados Fiscais Obrigatórios</p>
          <p className="text-xs text-muted-foreground mt-1">
            Estes campos são necessários para emissão de notas fiscais e conformidade legal
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="NCM (8 dígitos)"
          value={productData?.ncm}
          onChange={(e) => onFieldChange('ncm', e?.target?.value)}
          placeholder="00000000"
          maxLength={8}
          required
          error={validationErrors?.ncm}
          description="Nomenclatura Comum do Mercosul"
        />
        
        <Input
          label="CEST (7 dígitos)"
          value={productData?.cest}
          onChange={(e) => onFieldChange('cest', e?.target?.value)}
          placeholder="0000000"
          maxLength={7}
          description="Código Especificador da Substituição Tributária"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Origem"
          options={originOptions}
          value={productData?.origin}
          onChange={(value) => onFieldChange('origin', value)}
          required
        />
        
        <Input
          label="CFOP Padrão"
          value={productData?.cfop}
          onChange={(e) => onFieldChange('cfop', e?.target?.value)}
          placeholder="5102"
          maxLength={4}
          description="Código Fiscal de Operações e Prestações"
        />
      </div>

      {/* Info Card */}
      <div className="bg-muted/50 border border-border rounded-lg p-4">
        <h4 className="font-medium text-foreground mb-2">Referências Úteis</h4>
        <ul className="text-sm text-muted-foreground space-y-1">
          <li>• NCM: Consulte em <a href="https://www.gov.br/receitafederal" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Receita Federal</a></li>
          <li>• CEST: Obrigatório para produtos com substituição tributária</li>
          <li>• CFOP: Varia conforme operação (venda, transferência, etc.)</li>
        </ul>
      </div>
    </div>
  );
};

export default TaxDataTab;